import comp from "./CustomMessage";
export default comp;
